module.exports = __webpack_public_path__ + "img/ic-otc.45e2b926.png";